import React from "react";
import {
  Button,
  Dialog,
  DialogTitle,
  TextField,
  DialogActions,
  DialogContent
} from "@material-ui/core";
import styles from "./NewEntityDialog.module.scss";
import { useTranslation } from "react-i18next";

export function NewEntityDialog(props) {
  const { dialogTitle, confirmLabel, onCancel, onConfirm, onTitleChange, isOpen, title } = props;
  const [t, i18n] = useTranslation()

  function handleConfirm() {
    onConfirm();
  }

  function handleCancel() {
    onCancel();
  }

  function handleTitleChange(value) {
    onTitleChange(value);
  }

  return (
    <Dialog
      fullWidth={true}
      open={isOpen}
      aria-labelledby="scroll-dialog-title"
    >
      <DialogTitle id="scroll-dialog-title">{dialogTitle}</DialogTitle>
      <DialogContent>
        <TextField
          id="outlined-name"
          label={t('common.title')}
          value={title}
          onChange={event => {
            handleTitleChange(event.target.value);
          }}
          margin="dense"
          variant="outlined"
          className={styles.textField}
        />
      </DialogContent>
      <DialogActions>
        <Button onClick={() => handleCancel()} color="secondary">
          {t('common.cancel')}
        </Button>
        <Button onClick={() => handleConfirm()} color="secondary">
          {confirmLabel}
        </Button>
      </DialogActions>
    </Dialog>
  );
}
